import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

import axios from 'axios'
import VueAxios from 'vue-axios'

import actualidadModule from '@/store/actualidad'
import formulariosModule from '@/store/formularios'


import messages from '@/translations';


export const store = new Vuex.Store({
  state: {
    language: localStorage.getItem('language'),
    server: 'https://dmb.grupoian.com'
  },
  actions: {
    requestReceta: ({
      commit
    }, data) => {

      console.log(data);

      return new Promise((resolve) => {
        axios.post(`/api/recipe`, data).then(response => {
          resolve(response.data);
          
        });
      });
    },
    requestRecetaSlug: ({
      commit
    }, id) => {
      return new Promise((resolve) => {

        axios.get(`api/recipe${(id) ? '/'+id : ''}`).then(response => {

          resolve(response.data);
          
        });
      });
    },
    requestCategories: ({
      commit
    }, data) => {

      console.log(data);

      return new Promise((resolve) => {
        axios.post(`/api/category`, data).then(response => {
          resolve(response.data);

        });
      });
    },
    changeLanguage: ({
      commit
    }, requestedLang) => {
      return new Promise((resolve, reject) => {
        commit('setLanguage', requestedLang);
        resolve(requestedLang);
      });
    },
  },
  getters: {
    getLanguage: state => state.language,
    getServer: state => state.server,
    getTexts: state => {
      return messages[state.language];
    }
  },
  mutations: {
    setLanguage(state, lang) {
      state.language = lang;
      localStorage.setItem('language', lang);
    }
  },
  modules: {
    actualidadModule,
    formulariosModule
  }
});



// WEBPACK FOOTER //
// ./src/store/store.js